const ToggleSwitch = ({
  label,
  leftLabel,
  rightLabel,
  checked,
  onChange,
  wrapperClassName = "",
  disabled = false,
}) => {
  return (
    <div className={`toggle-wrapper ${wrapperClassName}`}>
      {label && (
        <label className="toggle-heading fw-bold mb-3 mt-3">{label}</label>
      )}

      <div
        className={`toggle-container d-flex align-items-center gap-3 ${
          disabled ? "disabled" : ""
        }`}
      >
        <span
          className={`toggle-label ${!checked ? "active" : ""}`}
          onClick={() => onChange(false)}
        >
          {leftLabel}
        </span>

        <div className="toggle-switch" onClick={() => onChange(!checked)}>
          <div className={`toggle-slider ${checked ? "checked" : ""}`} />
        </div>

        <span
          className={`toggle-label ${checked ? "active" : ""}`}
          onClick={() => onChange(true)}
        >
          {rightLabel}
        </span>
      </div>
    </div>
  );
};

export default ToggleSwitch;
